import Vue from 'vue';
import store from './store';
import ossUpload from '@/assets/script/lib/oss/upload'
import fileUpload from '@/assets/script/lib/oss/upload2'
import {cookie} from '@deanwu/vue-component-library'

let app = new Vue();

// Alpha [开发环境]; Beta [测试环境]; Preview [预发布环境]; Online [正式环境]
const RE = "Alpha";
const SERVER_ADDR = (re => {
	switch(re) {
	case 'Local':
	case 'Alpha':
		return '/develop';
	case 'Online':
		return '/api';
	}
})(RE);
const UPLOAD_ADDR = (re => {
	switch(re) {
	case 'Local':
	case 'Alpha':
		return 'https://test-channel-sales.xiaoheipaipai.com/api/images/upload-file';
	case 'Online':
		return 'https://prod-cn.your-api-server.com/api/images/upload-file';
	}
})(RE);

export default {
	request: {
		md5Key: 'V52kPpLS6msz7y3NfZUZ9OKFYeoGysMOeMSPdcObi6onvgmgKKEP5gk3s2omhDDOV3T6SYitc5bKUEzZECnEuN61YvObbu2SD7InNlnWeB8j7M195swDhAYjEnLAI71M',
		enKey: 'b2bc2dcff9074d84',
		deKey: '83fe4c23467507cd',
		log: RE != 'Online' || localStorage.getItem('debug') == 1,
		baseUrl: SERVER_ADDR,
		timeout: 60000,
		dataFormatter(data) {
			data.client = 2;
			data.session = store.state.session;
			return data;
		},
		response(data, requestQueue) {
			let message;
			switch (data.code) {
			case 9403:
			case 9405:
				message = '登录状态已失效，请重新登录';
				break;
			
			case 9505:
				message = '当前账号已在其他设备登录，您已被强制退出，如不是本人操作，请及时修改密码';
				break;
			}
			if (message) {
				if (!window._loginTimeoutConfirm) {
					window._loginTimeoutConfirm = true;
					app.$confirm({
						message,
						buttonName: '重新登录',
						cancelButton: false,
						resolve: () => {
							$app.$store.commit('setSession', '');
							$app.navigateTo(`/login?redirect=${$app.$route.fullPath}`);
							delete window._loginTimeoutConfirm;
						}
					});
				}
				for (let i in requestQueue) {
					requestQueue[i].abort();
				}
				return false;
			}
		}
	},
	
	theme: {
		main: '#3D5EFF',
		mainHover: '#5F7FFF',
		lesser: '#0D6EFE',
		lesserHover: '#3F8FFF',
		adorn: '#FF3333'
	},

	color: {
		link: ['#3D5EFF', '#5F7FFF'],
		red: ['#FF5555', '#FF3E3E'],
		green: ['#07B461', '#0AB462'],
		blue: ['#0D6EFE', '#2E7FFF'],
		yellow: ['#FFAB17', '#F89E00']
	},
	
	style: {
		unitLine: '#eee',

		buttonSize: {
			normal: {
				'height': '30px',
				'padding': '0 8px'
			},
			search: {
				'height': '32px',
				'border-radius': '2px',
				'padding': '0 10px',
				'font-size': '12px'
			},
			dialog: {
				'border-radius': '2px',
				'box-shadow': '0px 2px 3px 0px rgba(102,102,102,0.15)'
			}
		},
		
		table: {
			border: '#E5E5E5',  // 表格边框色
			headBackground: '#FAFAFA',  // 表头背景色
			rowBorder: '#ddd',  // 行边框色
			rowBorderStyle: 'dotted',  //  行边框类型
			rowEvenBackground: '#fff',
			rowHoverBackground: '#FFF883',  // 行移入背景色
			rowHlBackground: '#FFF883',  // 行选中背景色
			summedBackground: '#F2FFEB'  // 合计行背景色
		}
	},
	
	empty: {
		normal: {
			icon: require('@/assets/image/empty.png'),
			message: '暂无数据'
		},
	},

	config: {
		title: {
			icon: 'tf-title'
		},

		input: {
			heightResize: {
				type: 'auto',
				maxHeight: '160px'
			}
		},
		
		datetime: {
			defaultTime: 'now'
		},

		file: {
			uploadEvent(files, success) {
				fileUpload(files, {
					success
				});
				// let image = [], other = [];
				// files.forEach(item => {
				// 	let type = item.file.name.match(/\.[^\.]+$/)[0];
				// 	if (['.png', '.jpg', '.jpeg', '.gif'].includes(type)) {
				// 		image.push(item);
				// 	} else {
				// 		other.push(item);
				// 	}
				// });
				// if (image.length) {
				// 	fileUpload(image, {
				// 		success
				// 	});
				// }
				// if (other.length) {
				// 	ossUpload(other, {
				// 		success
				// 	});
				// }
			}
		},

		table: {
			colEllipsis: true,
			rowClickHl: true
		},
		
		form: {
			breakWhenFail: false
		},

		dialog: {
			maskClose: false,
			maskCloseEvent: 'click'
		}
	},
	
	data: {
		authority() {
			return store.state.authList;
		}
	}
}

export {RE, SERVER_ADDR, UPLOAD_ADDR}